import { createApiSlice } from 'app/createApiSlice'
import {
  API_PROJECT_GOALS,
  API_PROJECT_SUMMARY_DASHBOARD,
  API_SHARE_PROJECT,
  API_SHARE_PROJECT_GOALS,
  API_SHARE_PROJECT_SUMMARY,
} from 'utils/apiList'

export const projectDashboardListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'projectDashboardList/api',
  endpoints(builder) {
    return {
      fetchProjectSummaryDashboard: builder.query({
        query({ projectId }) {
          return {
            url: `/${API_PROJECT_SUMMARY_DASHBOARD}/${projectId}`,
          }
        },
      }),
      fetchProjectSummarySharedDashboard: builder.query({
        query({ projectId }) {
          return {
            url: `${API_SHARE_PROJECT_SUMMARY}/${projectId}`,
          }
        },
      }),
      editCurrentAmountProjectGoals: builder.mutation({
        query(payload) {
          return {
            url: `${API_PROJECT_GOALS}/${payload.id}`,
            method: 'PATCH',
            body: { currentAmount: payload.currentAmount },
          }
        },
      }),
      editCurrentAmountProjectSharedGoals: builder.mutation({
        query(payload) {
          return {
            url: `${API_SHARE_PROJECT_GOALS}/${payload.id}`,
            method: 'PATCH',
            body: { currentAmount: payload.currentAmount },
          }
        },
      }),
    }
  },
})

export const {
  useFetchProjectSummaryDashboardQuery,
  useLazyFetchProjectSummaryDashboardQuery,
  useEditCurrentAmountProjectGoalsMutation,
  useFetchProjectSummarySharedDashboardQuery,
  useLazyFetchProjectSummarySharedDashboardQuery,
  useEditCurrentAmountProjectSharedGoalsMutation,
} = projectDashboardListApiSlice
